import React, { useEffect, useState } from 'react'
import { Empty } from 'meinian-package/src/baseComponent'
import request from 'meinian-package/src/utils/request'
import Icon from 'meinian-package/src/component/icon'
import { Spin } from 'antd'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import BaseDrawer from '../baseDrawer'
import CreateInspiration from '../component/createInspiration'
import InspirationCard from '../component/inspirationCard'
import { DefaultRank, RANK_DEFAULT_VALUE } from '../../coll/layerSelect'
import styles from './index.module.less'

export default ({ visible, crateInspirationAuth, query, info, onClose }) => {
  const [data, setData] = useState([])
  const [params, setParams] = useState({
    rankStatus: RANK_DEFAULT_VALUE.rankStatus,
    topFirstStatus: RANK_DEFAULT_VALUE.topFirstStatus,
  })
  const [loading, setLoading] = useState(true)
  const fetchChildColls = async (_params = params) => {
    setLoading(true)
    const res = await request.post('/zhikuan/ins/inspiration/list-inspiration', {
      parentId: info.id,
      keyword: query.like,
      start: 0,
      pageSize: 1000,
      queryType: 3,
      shareUrl: query.shareUrl || undefined,
      ..._params,
    }).catch(() => {
      setLoading(false)
    })
    setLoading(false)
    setData(res.resultList)
  }
  console.log('RANK_DEFAULT_VALUE', RANK_DEFAULT_VALUE)

  const onTop = (id, topStatus, e) => {
    onSticky(id, topStatus, e)
    request.track({ code: 6400008, type: `置顶灵感集-${id}-${topStatus}` })
  }

  const onSticky = async (id, _topStatus, e) => {
    e && e.stopPropagation()
    if (_topStatus) {
      await request.get('/ins/inspiration/remove-top', { params: { inspirationId: id } })
    } else {
      await request.get('/ins/inspiration/set-top', { params: { inspirationId: id } })
    }
    fetchChildColls()
  }

  useEffect(() => {
    visible && fetchChildColls()
  }, [visible])

  return <BaseDrawer
    onClose={onClose}
    visible={visible}
    width={440}
    title={<div style={{ display: 'flex' }}>
      <div className={styles['mn-drawer-header-title']}>子灵感集</div>
      <div className={styles['mn-drawer-header-info']}><span style={{ marginLeft: '4px' }}>{data.length}</span></div>
      <div style={{ fontWeight: 400, marginLeft: '24px' }}>
        <DefaultRank
          value={params.rankStatus}
          onChange={(val) => {
            setParams(pre => ({ ...pre, rankStatus: val, }))
            fetchChildColls({ ...params, rankStatus: val, })
          }}
        />
      </div>
    </div>}
  >
    <Spin spinning={loading}>
      <div className={styles['mn-drawer-content']}>
        {crateInspirationAuth && <CreateInspiration info={info} style={{ width: '352px' }} onChange={() => fetchChildColls()} />}
        {
        data.length ? data?.map(item => <div className="mn-drawer-content-list-item-wrap">
          <div className="mn-drawer-content-list-item">
            <InspirationCard data={item} query={query} style={{ width: '352px' }} />
            <Tooltip
              placement="left"
              title={`${item.topStatus ? '取消置顶' : '置顶'}`}
            >
              <div
                className="mn-drawer-content-list-item-top fill-white-bg"
                onClick={(e) => onTop(item.id, item.topStatus, e)}
              >
                <Icon type={`${!item.topStatus ? 'm-zhiding1' : 'm-jiantou_xia'}`} />
              </div>
            </Tooltip>
          </div>
        </div>) : <Empty title="暂无相关子灵感集" type="ins" />
      }
      </div>
    </Spin>
  </BaseDrawer>
}
